// API Endpoints from environment
export const N8N_BASE_URL = import.meta.env.VITE_N8N_BASE_URL || '';
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || '';
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

// Deepgram API Configuration
export const DEEPGRAM_API_KEY = import.meta.env.VITE_DEEPGRAM_API_KEY || '';

// Google Gemini API Key for Vision Extraction
// Get your API key from https://aistudio.google.com/app/apikey
export const GEMINI_API_KEY = import.meta.env.VITE_GEMINI_API_KEY || '';

// Webhook URLs - Use proxied paths in development to avoid CORS
// The Vite proxy rewrites /api/n8n/* to /webhook/* on the N8N cloud
const isDev = import.meta.env.DEV;

// For production, use the full URLs; for development, use the proxied paths
// NOTE: This points to "Demo System - Create Demo" workflow which:
// 1. Gets available phone from pool
// 2. Creates Vapi assistant
// 3. Inserts demo record into database
// 4. Returns demoId, demoPhone, etc.
export const WEBHOOK_CREATE_DEMO = isDev
  ? '/api/n8n/58dfcf14-21fe-4395-a889-dd585c1bfe98'
  : 'https://baseanalytics.app.n8n.cloud/webhook/58dfcf14-21fe-4395-a889-dd585c1bfe98';

export const WEBHOOK_RELEASE_DEMO = isDev
  ? '/api/n8n/a1b2c3d4-5678-90ab-cdef-release12345'
  : 'https://baseanalytics.app.n8n.cloud/webhook/a1b2c3d4-5678-90ab-cdef-release12345';

// N8N webhooks for prospect search and scraping (N8N-First architecture)
export const WEBHOOK_SEARCH_PROSPECTS = isDev
  ? '/api/n8n/prod-search-prospects'
  : 'https://baseanalytics.app.n8n.cloud/webhook/prod-search-prospects';

export const WEBHOOK_SCRAPE_BUSINESS = isDev
  ? '/api/n8n/prod-scrape-business'
  : 'https://baseanalytics.app.n8n.cloud/webhook/prod-scrape-business';

// SerpAPI proxy Edge Function (broker prospecting)
export const EDGE_FUNCTION_SERPAPI = isDev
  ? 'http://127.0.0.1:54321/functions/v1/serpapi-proxy'
  : `${SUPABASE_URL}/functions/v1/serpapi-proxy`;

// Website content scraping webhook (for demo enrichment)
export const WEBHOOK_SCRAPE_WEBSITE = isDev
  ? '/api/n8n/prod-scrape-website'
  : 'https://baseanalytics.app.n8n.cloud/webhook/prod-scrape-website';

// Google Calendar Events webhook
export const WEBHOOK_CALENDAR_EVENTS = isDev
  ? '/api/n8n/calendar-events'
  : 'https://baseanalytics.app.n8n.cloud/webhook/calendar-events';

// Outbound Demo Call Trigger webhook
export const WEBHOOK_OUTBOUND_DEMO_TRIGGER = isDev
  ? '/api/n8n/outbound-demo-trigger'
  : (import.meta.env.VITE_N8N_OUTBOUND_DEMO_WEBHOOK || '');

// Equipment Survey Campaign Trigger webhook
// Triggered when high-value equipment observations are recorded
export const WEBHOOK_CAMPAIGN_TRIGGER = isDev
  ? '/api/n8n/campaign-trigger'
  : (import.meta.env.VITE_N8N_CAMPAIGN_TRIGGER_WEBHOOK || '');

// Technician Job Status Webhooks
export const WEBHOOK_DISPATCH = isDev
  ? '/api/n8n/prod-tech-dispatch'
  : (import.meta.env.VITE_N8N_DISPATCH_WEBHOOK || 'https://baseanalytics.app.n8n.cloud/webhook/prod-tech-dispatch');

export const WEBHOOK_ARRIVAL = isDev
  ? '/api/n8n/prod-tech-arrival'
  : (import.meta.env.VITE_N8N_ARRIVAL_WEBHOOK || 'https://baseanalytics.app.n8n.cloud/webhook/prod-tech-arrival');

// Demo lead capture (public demo request page)
export const WEBHOOK_CAPTURE_LEAD = isDev
  ? '/api/n8n/capture-demo-lead'
  : 'https://baseanalytics.app.n8n.cloud/webhook/capture-demo-lead';

// Public demo assistant creation/cleanup
export const WEBHOOK_CREATE_DEMO_ASSISTANT = isDev
  ? '/api/n8n/prod-create-demo-assistant'
  : 'https://baseanalytics.app.n8n.cloud/webhook/prod-create-demo-assistant';

export const WEBHOOK_CLEANUP_DEMO_ASSISTANT = isDev
  ? '/api/n8n/prod-cleanup-demo-assistant'
  : 'https://baseanalytics.app.n8n.cloud/webhook/prod-cleanup-demo-assistant';

// Tenant onboarding webhooks
export const WEBHOOK_CREATE_TENANT = isDev
  ? '/api/n8n/prod-create-tenant'
  : 'https://baseanalytics.app.n8n.cloud/webhook/prod-create-tenant';

export const WEBHOOK_PROVISION_TWILIO = isDev
  ? '/api/n8n/prod-provision-twilio-number'
  : 'https://baseanalytics.app.n8n.cloud/webhook/prod-provision-twilio-number';

export const WEBHOOK_FINALIZE_ONBOARDING = isDev
  ? '/api/n8n/prod-finalize-onboarding'
  : 'https://baseanalytics.app.n8n.cloud/webhook/prod-finalize-onboarding';

// Survey completion notification
export const WEBHOOK_SURVEY_COMPLETE = isDev
  ? '/api/n8n/prod-survey-complete'
  : 'https://baseanalytics.app.n8n.cloud/webhook/prod-survey-complete';

// Phone number provisioning (settings page)
export const WEBHOOK_PROVISION_PHONE = isDev
  ? '/api/n8n/prod-provision-phone-number'
  : 'https://baseanalytics.app.n8n.cloud/webhook/prod-provision-phone-number';

// Voice assistant management
export const WEBHOOK_UPDATE_VOICE = isDev
  ? '/api/n8n/prod-update-assistant-voice'
  : 'https://baseanalytics.app.n8n.cloud/webhook/prod-update-assistant-voice';

export const WEBHOOK_UPDATE_VAPI_PROMPT = isDev
  ? '/api/n8n/prod-update-vapi-prompt'
  : 'https://baseanalytics.app.n8n.cloud/webhook/prod-update-vapi-prompt';

export const WEBHOOK_DELETE_VAPI_ASSISTANT = isDev
  ? '/api/n8n/prod-delete-vapi-assistant'
  : 'https://baseanalytics.app.n8n.cloud/webhook/prod-delete-vapi-assistant';

// Demo business search
export const WEBHOOK_SEARCH_DEMO_BUSINESS = isDev
  ? '/api/n8n/prod-search-demo-business'
  : 'https://baseanalytics.app.n8n.cloud/webhook/prod-search-demo-business';

// Website scanning (prospects)
export const WEBHOOK_DEMO_SCAN_WEBSITE = isDev
  ? '/api/n8n/demo-scan-website'
  : 'https://baseanalytics.app.n8n.cloud/webhook/demo-scan-website';

// Phone pool sync — discover Vapi numbers not yet in pool, add them
export const WEBHOOK_PHONE_POOL_SYNC = isDev
  ? '/api/n8n/prod-phone-pool-sync'
  : 'https://baseanalytics.app.n8n.cloud/webhook/prod-phone-pool-sync';

// Mortgage broker deployment webhooks
export const WEBHOOK_MORTGAGE_DEPLOY = isDev
  ? '/api/n8n/mortgage-deploy'
  : 'https://baseanalytics.app.n8n.cloud/webhook/mortgage-deploy';

export const WEBHOOK_MORTGAGE_FETCH_REVIEWS = isDev
  ? '/api/n8n/mortgage-fetch-reviews'
  : 'https://baseanalytics.app.n8n.cloud/webhook/mortgage-fetch-reviews';

export const WEBHOOK_MORTGAGE_ANALYZE_REVIEWS = isDev
  ? '/api/n8n/mortgage-analyze-reviews'
  : 'https://baseanalytics.app.n8n.cloud/webhook/mortgage-analyze-reviews';

// Demo settings
export const DEMO_DURATION_HOURS = 1;
export const PHONE_COOLDOWN_MINUTES = 5;

// ══════════════════════════════════════════════════════════════════
// CANONICAL VOICE OPTIONS — Single Source of Truth
// ══════════════════════════════════════════════════════════════════
// Add new voices HERE. All UI components import from this array.
// Also update: lib/buildReceptionistPrompt.js VOICE_NAME_MAP
//              MORTGAGE_BROKERS/MASTER_VAPI_ASSISTANT_SETTINGS.md Section 2
//              .claude/skills/vapi-assistant-setup/SKILL.md
// ══════════════════════════════════════════════════════════════════
export const VOICE_OPTIONS = [
  {
    id: 'EXAVITQu4vr4xnSDxMaL',
    name: 'Sarah',
    gender: 'female' as const,
    description: 'Mature, reassuring',
    previewText: "Hello, this is Sarah. I have years of experience making sure every caller feels heard and taken care of. You're in good hands with me answering your phones.",
  },
  {
    id: 'cgSgspJ2msm6clMCkdW9',
    name: 'Jessica',
    gender: 'female' as const,
    description: 'Playful, bright',
    previewText: "Hey! I'm Jessica! I absolutely love talking to people and making their day a little brighter. Your customers are gonna love chatting with me!",
  },
  {
    id: 'FGY2WhTYpPnrIDTdsKH5',
    name: 'Laura',
    gender: 'female' as const,
    description: 'Enthusiastic, energetic',
    previewText: "Oh hi! I'm Laura and I am SO excited to be your receptionist! Seriously, I bring the energy to every single call. Let's do this!",
  },
  {
    id: 'nPczCjzI2devNBz1zQrb',
    name: 'Brian',
    gender: 'male' as const,
    description: 'Deep, resonant narrator',
    previewText: "Hello there. This is Brian. I bring a deep, resonant voice that carries well and sounds authoritative. Your customers will appreciate the clear, confident tone.",
  },
  {
    id: 'cjVigY5qzO86Huf0OWal',
    name: 'Eric',
    gender: 'male' as const,
    description: 'Smooth, trustworthy',
    previewText: "Hey! Eric here. I've got a friendly, approachable style that puts people right at ease. Your callers will feel like they're talking to someone they can trust.",
  },
  {
    id: 'iP95p4xoKVk53GoZ742B',
    name: 'Ryan',
    gender: 'male' as const,
    description: 'Charming, down-to-earth',
    previewText: "Hey there! Ryan here. I've got a friendly, down-to-earth style that makes callers feel right at home. Professional but approachable - that's my thing.",
  },
] as const;

export type VoiceOption = typeof VOICE_OPTIONS[number];

// Default voice ID (Sarah - most commonly used)
export const DEFAULT_VOICE_ID = 'EXAVITQu4vr4xnSDxMaL';

// Backwards-compatible aliases
export const DEMO_VOICE_OPTIONS = VOICE_OPTIONS;
export const DEFAULT_DEMO_VOICE_ID = DEFAULT_VOICE_ID;

// Time thresholds for UI
export const WARNING_THRESHOLD_MINUTES = 20;
export const CRITICAL_THRESHOLD_MINUTES = 5;

// Regions - All US states and territories
export const REGIONS = [
  // West Coast
  { value: 'CA', label: 'California' },
  { value: 'WA', label: 'Washington' },
  { value: 'OR', label: 'Oregon' },
  { value: 'NV', label: 'Nevada' },
  { value: 'AK', label: 'Alaska' },
  { value: 'HI', label: 'Hawaii' },
  // Southwest
  { value: 'AZ', label: 'Arizona' },
  { value: 'NM', label: 'New Mexico' },
  { value: 'UT', label: 'Utah' },
  { value: 'CO', label: 'Colorado' },
  // Mountain/Northwest
  { value: 'ID', label: 'Idaho' },
  { value: 'MT', label: 'Montana' },
  { value: 'WY', label: 'Wyoming' },
  // Texas
  { value: 'TX', label: 'Texas' },
  // Midwest
  { value: 'IL', label: 'Illinois' },
  { value: 'MI', label: 'Michigan' },
  { value: 'OH', label: 'Ohio' },
  { value: 'IN', label: 'Indiana' },
  { value: 'WI', label: 'Wisconsin' },
  { value: 'MN', label: 'Minnesota' },
  { value: 'IA', label: 'Iowa' },
  { value: 'MO', label: 'Missouri' },
  { value: 'KS', label: 'Kansas' },
  { value: 'NE', label: 'Nebraska' },
  { value: 'ND', label: 'North Dakota' },
  { value: 'SD', label: 'South Dakota' },
  // Southeast
  { value: 'FL', label: 'Florida' },
  { value: 'GA', label: 'Georgia' },
  { value: 'NC', label: 'North Carolina' },
  { value: 'SC', label: 'South Carolina' },
  { value: 'VA', label: 'Virginia' },
  { value: 'TN', label: 'Tennessee' },
  { value: 'KY', label: 'Kentucky' },
  { value: 'AL', label: 'Alabama' },
  { value: 'MS', label: 'Mississippi' },
  { value: 'LA', label: 'Louisiana' },
  { value: 'AR', label: 'Arkansas' },
  { value: 'OK', label: 'Oklahoma' },
  // Northeast
  { value: 'NY', label: 'New York' },
  { value: 'PA', label: 'Pennsylvania' },
  { value: 'NJ', label: 'New Jersey' },
  { value: 'MA', label: 'Massachusetts' },
  { value: 'CT', label: 'Connecticut' },
  { value: 'RI', label: 'Rhode Island' },
  { value: 'ME', label: 'Maine' },
  { value: 'NH', label: 'New Hampshire' },
  { value: 'VT', label: 'Vermont' },
  { value: 'DE', label: 'Delaware' },
  { value: 'MD', label: 'Maryland' },
  { value: 'DC', label: 'District of Columbia' },
  { value: 'WV', label: 'West Virginia' },
] as const;

// Industries with keywords for autocomplete matching
// NOTE: Order matches display_order in industry_templates table
// Icons match Lucide icon names used in the database
export const INDUSTRIES = [
  // Core home service industries
  { value: 'hvac', label: 'HVAC', icon: 'flame', keywords: ['hvac', 'heating', 'cooling', 'furnace', 'air condition', 'ac', 'heat pump', 'boiler', 'ventilation', 'climate', 'ductwork'] },
  { value: 'plumbing', label: 'Plumbing', icon: 'droplet', keywords: ['plumb', 'drain', 'pipe', 'water heater', 'sewer', 'septic', 'bathroom', 'toilet', 'faucet', 'leak'] },
  { value: 'both', label: 'Plumbing & HVAC', icon: 'settings', keywords: ['mechanical', 'plumbing hvac', 'hvac plumbing'] },
  { value: 'electrical', label: 'Electrical', icon: 'zap', keywords: ['electric', 'wiring', 'outlet', 'panel', 'circuit', 'breaker', 'electrician', 'power', 'lighting'] },
  { value: 'appliance', label: 'Appliance Repair', icon: 'refrigerator', keywords: ['appliance', 'washer', 'dryer', 'refrigerator', 'dishwasher', 'oven', 'stove', 'microwave', 'fridge'] },
  // New industries
  { value: 'garage_door', label: 'Garage Door', icon: 'door-closed', keywords: ['garage door', 'overhead door', 'door opener', 'spring', 'garage repair', 'door installation'] },
  { value: 'roofing', label: 'Roofing', icon: 'home', keywords: ['roof', 'roofing', 'shingle', 'gutter', 'leak', 'roofer', 'siding', 'soffit', 'fascia', 'eaves'] },
  { value: 'locksmith', label: 'Locksmith', icon: 'key', keywords: ['locksmith', 'lock', 'key', 'deadbolt', 'lockout', 'safe', 'security', 'door lock', 'rekey'] },
  { value: 'pest_control', label: 'Pest Control', icon: 'bug', keywords: ['pest', 'exterminator', 'rodent', 'termite', 'bug', 'insect', 'mice', 'rat', 'ant', 'wasp', 'bee'] },
  { value: 'landscaping', label: 'Landscaping', icon: 'tree-deciduous', keywords: ['landscape', 'lawn', 'yard', 'garden', 'irrigation', 'tree', 'grass', 'mowing', 'snow removal'] },
  { value: 'pool_service', label: 'Pool Service', icon: 'waves', keywords: ['pool', 'spa', 'hot tub', 'swimming', 'pool cleaning', 'pool repair', 'jacuzzi'] },
  { value: 'chimney', label: 'Chimney Service', icon: 'flame', keywords: ['chimney', 'fireplace', 'chimney sweep', 'flue', 'wood stove', 'chimney cleaning', 'chimney repair'] },
  { value: 'windows_doors', label: 'Windows & Doors', icon: 'square', keywords: ['window', 'door', 'glass', 'screen', 'window replacement', 'door installation', 'patio door'] },
  { value: 'cleaning', label: 'Cleaning Services', icon: 'sparkles', keywords: ['cleaning', 'maid', 'house cleaning', 'carpet', 'janitorial', 'housekeeping', 'deep clean'] },
  { value: 'handyman', label: 'Handyman', icon: 'wrench', keywords: ['handyman', 'general contractor', 'repair', 'fix', 'odd jobs', 'home repair', 'maintenance'] },
] as const;

// Industry type for type-safe usage
export type IndustryCode = typeof INDUSTRIES[number]['value'];

// Status colors
export const STATUS_COLORS = {
  available: 'bg-green-500',
  assigned: 'bg-blue-500',
  cooldown: 'bg-yellow-500',
  disabled: 'bg-gray-500',
  active: 'bg-green-500',
  expired: 'bg-red-500',
  released: 'bg-gray-500',
  creating: 'bg-blue-500',
  converted: 'bg-purple-500',
  failed: 'bg-red-500',
} as const;

// Navigation items for Sales Portal
// Note: Campaigns feature deferred to March 2026 - nav item removed
export const SALES_NAV_ITEMS = [
  {
    title: 'Dashboard',
    href: '/sales',
    icon: 'LayoutDashboard',
  },
  {
    title: 'Pipeline',
    href: '/sales/pipeline',
    icon: 'TrendingUp',
  },
  {
    title: 'Prospects',
    href: '/sales/prospects',
    icon: 'Users',
  },
  {
    title: 'History',
    href: '/sales/history',
    icon: 'History',
  },
] as const;

// Campaign Types
export const CAMPAIGN_TYPES = [
  { value: 'seasonal_tuneup', label: 'Seasonal Tune-Up' },
  { value: 'maintenance_plan', label: 'Maintenance Plan' },
  { value: 'equipment_followup', label: 'Equipment Follow-Up' },
  { value: 'win_back', label: 'Win-Back Campaign' },
  { value: 'new_service', label: 'New Service Announcement' },
  { value: 'promotion', label: 'Limited-Time Promotion' },
] as const;

// Campaign Status Colors
export const CAMPAIGN_STATUS_COLORS = {
  draft: 'bg-gray-500/20 text-gray-500',
  active: 'bg-green-500/20 text-green-500',
  paused: 'bg-yellow-500/20 text-yellow-500',
  completed: 'bg-blue-500/20 text-blue-500',
  cancelled: 'bg-red-500/20 text-red-500',
} as const;

// Pipeline Stage Labels
export const PIPELINE_STAGE_LABELS = {
  new_lead: 'New Lead',
  demo_sent: 'Demo Sent',
  demo_engaged: 'Demo Engaged',
  follow_up: 'Follow-up',
  interested: 'Interested',
  proposal_sent: 'Proposal Sent',
  negotiating: 'Negotiating',
  won: 'Won',
  lost: 'Lost',
  nurture: 'Nurture',
} as const;

// Pipeline Stage Colors
export const PIPELINE_STAGE_COLORS = {
  new_lead: 'bg-slate-500',
  demo_sent: 'bg-blue-500',
  demo_engaged: 'bg-cyan-500',
  follow_up: 'bg-yellow-500',
  interested: 'bg-orange-500',
  proposal_sent: 'bg-purple-500',
  negotiating: 'bg-pink-500',
  won: 'bg-green-500',
  lost: 'bg-red-500',
  nurture: 'bg-indigo-500',
} as const;

// Stripe Configuration
export const STRIPE_PUBLISHABLE_KEY = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '';

// Stripe Price IDs - Map to your Stripe Dashboard price IDs
// Tier names: starter, growth, dominator (March 2026 rebrand)
// Supports legacy env var names for backward compatibility

// Annual Plans (12-month commitment, ~15% discount, setup fee still applies)
export const STRIPE_PRICES_ANNUAL = {
  starter: import.meta.env.VITE_STRIPE_PRICE_STARTER_ANNUAL || import.meta.env.VITE_STRIPE_PRICE_CORE_ANNUAL || import.meta.env.VITE_STRIPE_PRICE_RECEPTIONIST_ANNUAL || '',
  growth: import.meta.env.VITE_STRIPE_PRICE_GROWTH_ANNUAL || import.meta.env.VITE_STRIPE_PRICE_PROFESSIONAL_ANNUAL || import.meta.env.VITE_STRIPE_PRICE_OUTBOUND_ANNUAL || '',
  dominator: import.meta.env.VITE_STRIPE_PRICE_DOMINATOR_ANNUAL || import.meta.env.VITE_STRIPE_PRICE_COMPLETE_ANNUAL || '',
  mortgage_broker: import.meta.env.VITE_STRIPE_PRICE_MORTGAGE_BROKER_ANNUAL || '',
  // Legacy keys (backward compat — point to same prices)
  receptionist: import.meta.env.VITE_STRIPE_PRICE_STARTER_ANNUAL || import.meta.env.VITE_STRIPE_PRICE_CORE_ANNUAL || import.meta.env.VITE_STRIPE_PRICE_RECEPTIONIST_ANNUAL || '',
  outbound: import.meta.env.VITE_STRIPE_PRICE_GROWTH_ANNUAL || import.meta.env.VITE_STRIPE_PRICE_PROFESSIONAL_ANNUAL || import.meta.env.VITE_STRIPE_PRICE_OUTBOUND_ANNUAL || '',
  complete: import.meta.env.VITE_STRIPE_PRICE_DOMINATOR_ANNUAL || import.meta.env.VITE_STRIPE_PRICE_COMPLETE_ANNUAL || '',
} as const;

// Month-to-Month Plans (setup fee charged separately)
export const STRIPE_PRICES_MONTHLY = {
  starter: import.meta.env.VITE_STRIPE_PRICE_STARTER_MONTHLY || import.meta.env.VITE_STRIPE_PRICE_CORE_MONTHLY || import.meta.env.VITE_STRIPE_PRICE_RECEPTIONIST_MONTHLY || '',
  growth: import.meta.env.VITE_STRIPE_PRICE_GROWTH_MONTHLY || import.meta.env.VITE_STRIPE_PRICE_PROFESSIONAL_MONTHLY || import.meta.env.VITE_STRIPE_PRICE_OUTBOUND_MONTHLY || '',
  dominator: import.meta.env.VITE_STRIPE_PRICE_DOMINATOR_MONTHLY || import.meta.env.VITE_STRIPE_PRICE_COMPLETE_MONTHLY || '',
  mortgage_broker: import.meta.env.VITE_STRIPE_PRICE_MORTGAGE_BROKER_MONTHLY || '',
  // Legacy keys (backward compat)
  receptionist: import.meta.env.VITE_STRIPE_PRICE_STARTER_MONTHLY || import.meta.env.VITE_STRIPE_PRICE_CORE_MONTHLY || import.meta.env.VITE_STRIPE_PRICE_RECEPTIONIST_MONTHLY || '',
  outbound: import.meta.env.VITE_STRIPE_PRICE_GROWTH_MONTHLY || import.meta.env.VITE_STRIPE_PRICE_PROFESSIONAL_MONTHLY || import.meta.env.VITE_STRIPE_PRICE_OUTBOUND_MONTHLY || '',
  complete: import.meta.env.VITE_STRIPE_PRICE_DOMINATOR_MONTHLY || import.meta.env.VITE_STRIPE_PRICE_COMPLETE_MONTHLY || '',
} as const;

// Setup Fee Price IDs (one-time charges — always apply, both annual and monthly)
export const STRIPE_SETUP_FEES = {
  starter: import.meta.env.VITE_STRIPE_SETUP_FEE_STARTER || import.meta.env.VITE_STRIPE_SETUP_FEE_CORE || import.meta.env.VITE_STRIPE_SETUP_FEE_RECEPTIONIST || '',
  growth: import.meta.env.VITE_STRIPE_SETUP_FEE_GROWTH || import.meta.env.VITE_STRIPE_SETUP_FEE_PROFESSIONAL || import.meta.env.VITE_STRIPE_SETUP_FEE_OUTBOUND || '',
  dominator: import.meta.env.VITE_STRIPE_SETUP_FEE_DOMINATOR || import.meta.env.VITE_STRIPE_SETUP_FEE_COMPLETE || '',
  mortgage_broker: import.meta.env.VITE_STRIPE_SETUP_FEE_MORTGAGE_BROKER || '',
  // Legacy keys (backward compat)
  receptionist: import.meta.env.VITE_STRIPE_SETUP_FEE_STARTER || import.meta.env.VITE_STRIPE_SETUP_FEE_CORE || import.meta.env.VITE_STRIPE_SETUP_FEE_RECEPTIONIST || '',
  outbound: import.meta.env.VITE_STRIPE_SETUP_FEE_GROWTH || import.meta.env.VITE_STRIPE_SETUP_FEE_PROFESSIONAL || import.meta.env.VITE_STRIPE_SETUP_FEE_OUTBOUND || '',
  complete: import.meta.env.VITE_STRIPE_SETUP_FEE_DOMINATOR || import.meta.env.VITE_STRIPE_SETUP_FEE_COMPLETE || '',
} as const;

// Legacy export for backward compatibility
export const STRIPE_PRICES = STRIPE_PRICES_ANNUAL;

// Subscription Tiers — canonical names (March 2026 rebrand)
export const SUBSCRIPTION_TIERS = {
  // HVAC/Plumbing tiers (legacy, still active for existing tenants)
  starter: 'starter',       // $649/mo — AI Phone + Website + Calendar + Dashboard + SMS
  growth: 'growth',         // $899/mo — + Web Chat, SMS Marketing, Reviews, Testimonials
  dominator: 'dominator',   // $1,199/mo — + Google 3-Pack, GBP, Local SEO, Strategy Calls
  // Mortgage Broker tier — single all-inclusive tier (March 2026)
  mortgage_broker: 'mortgage_broker', // $1,200/mo ($999 annual) — ALL features, $2,999 setup
  // Legacy aliases (for existing code that references old names)
  receptionist: 'starter',
  outbound: 'growth',
  complete: 'dominator',
} as const;

export type SubscriptionTier = 'starter' | 'growth' | 'dominator' | 'mortgage_broker' | 'receptionist' | 'outbound' | 'complete';

// Legacy tier name → new tier name mapping
export const LEGACY_TIER_MAP: Record<string, string> = {
  receptionist: 'starter',
  outbound: 'growth',
  complete: 'dominator',
  core: 'starter',
  professional: 'growth',
};

/**
 * Normalize any tier name (legacy or new) to the canonical tier name.
 */
export function normalizeTierName(tier: string | null): 'starter' | 'growth' | 'dominator' | 'mortgage_broker' {
  if (!tier) return 'starter';
  const lower = tier.toLowerCase();
  if (lower === 'mortgage_broker') return 'mortgage_broker';
  if (lower in LEGACY_TIER_MAP) return LEGACY_TIER_MAP[lower] as 'starter' | 'growth' | 'dominator';
  if (lower === 'starter' || lower === 'growth' || lower === 'dominator') return lower;
  return 'starter'; // Unknown tiers default to starter
}

// Tier hierarchy for permission checks (higher number = more features)
export const TIER_HIERARCHY: Record<SubscriptionTier, number> = {
  starter: 1,
  growth: 2,
  dominator: 3,
  mortgage_broker: 3, // All-inclusive — same level as dominator
  // Legacy aliases
  receptionist: 1,
  outbound: 2,
  complete: 3,
} as const;

// Feature flags by tier — which features are available at each tier
export const TIER_FEATURES = {
  starter: {
    aiPhoneSystem: true,
    professionalWebsite: true,
    businessDashboard: true,
    googleCalendar: true,
    smsConfirmations: true,
    webChat: false,
    smsMarketing: false,
    testimonialGraphics: false,
    reviewIntelligence: false,
    aiReviewResponses: false,
    google3Pack: false,
    gbpManagement: false,
    localSeo: false,
    strategyCalls: false,
    prioritySupport: false,
    maxTechnicians: 1,
    // Legacy feature aliases (for existing code)
    aiReceptionist: true,
    techPortal: false,
    voiceToText: false,
    smartDispatch: false,
    equipmentSurvey: false,
  },
  growth: {
    aiPhoneSystem: true,
    professionalWebsite: true,
    businessDashboard: true,
    googleCalendar: true,
    smsConfirmations: true,
    webChat: true,
    smsMarketing: true,
    testimonialGraphics: true,
    reviewIntelligence: true,
    aiReviewResponses: true,
    google3Pack: false,
    gbpManagement: false,
    localSeo: false,
    strategyCalls: false,
    prioritySupport: false,
    maxTechnicians: 5,
    // Legacy feature aliases
    aiReceptionist: true,
    techPortal: true,
    voiceToText: true,
    smartDispatch: true,
    equipmentSurvey: false,
  },
  dominator: {
    aiPhoneSystem: true,
    professionalWebsite: true,
    businessDashboard: true,
    googleCalendar: true,
    smsConfirmations: true,
    webChat: true,
    smsMarketing: true,
    testimonialGraphics: true,
    reviewIntelligence: true,
    aiReviewResponses: true,
    google3Pack: true,
    gbpManagement: true,
    localSeo: true,
    strategyCalls: true,
    prioritySupport: true,
    maxTechnicians: -1, // Unlimited
    // Legacy feature aliases
    aiReceptionist: true,
    techPortal: true,
    voiceToText: true,
    smartDispatch: true,
    equipmentSurvey: true,
  },
  // Mortgage Broker tier — ALL features enabled, single all-inclusive tier
  mortgage_broker: {
    aiPhoneSystem: true,
    professionalWebsite: true,
    businessDashboard: true,
    googleCalendar: true,
    smsConfirmations: true,
    webChat: true,
    smsMarketing: true,
    testimonialGraphics: true,
    reviewIntelligence: true,
    aiReviewResponses: true,
    google3Pack: true,
    gbpManagement: true,
    localSeo: true,
    strategyCalls: true,
    prioritySupport: true,
    maxTechnicians: -1, // Unlimited
    // Legacy feature aliases
    aiReceptionist: true,
    techPortal: true,
    voiceToText: true,
    smartDispatch: true,
    equipmentSurvey: true,
  },
  // Legacy tier keys — point to canonical tier features
  receptionist: {
    aiPhoneSystem: true,
    professionalWebsite: true,
    businessDashboard: true,
    googleCalendar: true,
    smsConfirmations: true,
    webChat: false,
    smsMarketing: false,
    testimonialGraphics: false,
    reviewIntelligence: false,
    aiReviewResponses: false,
    google3Pack: false,
    gbpManagement: false,
    localSeo: false,
    strategyCalls: false,
    prioritySupport: false,
    maxTechnicians: 1,
    aiReceptionist: true,
    techPortal: false,
    voiceToText: false,
    smartDispatch: false,
    equipmentSurvey: false,
  },
  outbound: {
    aiPhoneSystem: true,
    professionalWebsite: true,
    businessDashboard: true,
    googleCalendar: true,
    smsConfirmations: true,
    webChat: true,
    smsMarketing: true,
    testimonialGraphics: true,
    reviewIntelligence: true,
    aiReviewResponses: true,
    google3Pack: false,
    gbpManagement: false,
    localSeo: false,
    strategyCalls: false,
    prioritySupport: false,
    maxTechnicians: 5,
    aiReceptionist: true,
    techPortal: true,
    voiceToText: true,
    smartDispatch: true,
    equipmentSurvey: false,
  },
  complete: {
    aiPhoneSystem: true,
    professionalWebsite: true,
    businessDashboard: true,
    googleCalendar: true,
    smsConfirmations: true,
    webChat: true,
    smsMarketing: true,
    testimonialGraphics: true,
    reviewIntelligence: true,
    aiReviewResponses: true,
    google3Pack: true,
    gbpManagement: true,
    localSeo: true,
    strategyCalls: true,
    prioritySupport: true,
    maxTechnicians: -1,
    aiReceptionist: true,
    techPortal: true,
    voiceToText: true,
    smartDispatch: true,
    equipmentSurvey: true,
  },
} as const;

export type TierFeature = keyof typeof TIER_FEATURES.starter;

// Pricing Display Data (USD) — Must match Pricing.tsx
export const PRICING_DATA = {
  starter: {
    name: 'Starter',
    annual: { monthly: 549, setup: 1200, yearOne: 7788 },   // $549/mo x 12 + $1,200 = $7,788
    monthly: { monthly: 649, setup: 1200, yearOne: 8988 },   // $649/mo x 12 + $1,200 = $8,988
    includedMinutes: 1000,
  },
  growth: {
    name: 'Growth',
    annual: { monthly: 769, setup: 1400, yearOne: 10628 },   // $769/mo x 12 + $1,400 = $10,628
    monthly: { monthly: 899, setup: 1400, yearOne: 12188 },   // $899/mo x 12 + $1,400 = $12,188
    includedMinutes: 1500,
  },
  dominator: {
    name: 'Dominator',
    annual: { monthly: 1019, setup: 1700, yearOne: 13928 },   // $1,019/mo x 12 + $1,700 = $13,928
    monthly: { monthly: 1199, setup: 1700, yearOne: 16088 },  // $1,199/mo x 12 + $1,700 = $16,088
    includedMinutes: 2500,
  },
  // Mortgage Broker tier — single all-inclusive pricing (March 2026)
  mortgage_broker: {
    name: 'Business Operations Platform',
    annual: { monthly: 999, setup: 2999, yearOne: 14987 },   // $999/mo x 12 + $2,999 = $14,987
    monthly: { monthly: 1200, setup: 2999, yearOne: 17399 },  // $1,200/mo x 12 + $2,999 = $17,399
    includedMinutes: 2500,
  },
  // Legacy keys for backward compat
  receptionist: {
    name: 'Starter',
    annual: { monthly: 549, setup: 1200, yearOne: 7788 },
    monthly: { monthly: 649, setup: 1200, yearOne: 8988 },
    includedMinutes: 1000,
  },
  outbound: {
    name: 'Growth',
    annual: { monthly: 769, setup: 1400, yearOne: 10628 },
    monthly: { monthly: 899, setup: 1400, yearOne: 12188 },
    includedMinutes: 1500,
  },
  complete: {
    name: 'Dominator',
    annual: { monthly: 1019, setup: 1700, yearOne: 13928 },
    monthly: { monthly: 1199, setup: 1700, yearOne: 16088 },
    includedMinutes: 2500,
  },
} as const;

// Overage rate per minute
export const OVERAGE_RATE_PER_MINUTE = 0.25;

// Edge Function URLs
export const EDGE_FUNCTION_CREATE_CHECKOUT = `${SUPABASE_URL}/functions/v1/create-checkout-session`;
export const EDGE_FUNCTION_STRIPE_WEBHOOK = `${SUPABASE_URL}/functions/v1/stripe-webhook`;
export const EDGE_FUNCTION_BILLING_PORTAL = `${SUPABASE_URL}/functions/v1/create-billing-portal-session`;

